var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"firebaseui-auth-container"}}),_vm._v(" "),(_vm.player.isAnonymous)?_c('el-row'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }